// extracted by mini-css-extract-plugin
module.exports = {"spinner":"ProgressSpinner_spinner__2sY7E","lds-spinner":"ProgressSpinner_lds-spinner__r6TSk"};